import PropTypes from 'prop-types';

import Reactions from 'hb-react/frontoffice/components/Reactions';
import toggleLike from 'hb-react/shared/components/DesignSystem/Reactions/utils/toggleLike';

const CommentsContainer = ({ event_id: eventId, likes }) => (
  <Reactions
    key={`NetworkEvents::Event:${eventId}`}
    displayCommentsByDefault
    id={eventId}
    initialLikes={likes}
    onTogglePostLike={toggleLike}
    railsType="NetworkEvents::Event"
    type="NetworkEvents::Event"
  />
);

CommentsContainer.propTypes = {
  event_id: PropTypes.number.isRequired,
  likes: PropTypes.shape({
    likeable_id: PropTypes.number,
    count: PropTypes.number,
    id: PropTypes.number,
    users: PropTypes.array,
  }).isRequired,
};

export default CommentsContainer;
